// Service pour charger et gérer les métadonnées des épisodes
export class MetadataService {
  static metadataCache = null

  static async loadAllMetadata() {
    try {
      // Charger la liste des fichiers depuis l'index généré automatiquement
      const metadataFiles = await this.loadMetadataIndex()

      const metadata = await Promise.all(
        metadataFiles.map(async (filename) => {
          try {
            // Charger depuis le dossier public
            const response = await fetch(`${import.meta.env.BASE_URL}data/metadata/${filename}`)
            if (!response.ok) {
              console.warn(`Fichier de métadonnées non trouvé: ${filename} (${response.status})`)
              return null
            }
            const data = await response.json()
            
            return data
          } catch (error) {
            console.warn(`Impossible de charger les métadonnées ${filename}:`, error.message)
            return null
          }
        })
      )

      // Filtrer les métadonnées qui n'ont pas pu être chargées
      const validMetadata = metadata.filter(meta => meta !== null)

      if (validMetadata.length > 0) {
        console.log(`✅ Chargé ${validMetadata.length} métadonnées sur ${metadataFiles.length} tentatives`)
      } else {
        console.warn(`⚠️ Aucune métadonnée chargée sur ${metadataFiles.length} tentatives`)
      }
      
      // Mettre en cache les métadonnées
      this.metadataCache = validMetadata
      return validMetadata
    } catch (error) {
      console.error('Erreur lors du chargement des métadonnées:', error)
      return []
    }
  }

  // Charger la liste des fichiers de métadonnées depuis l'index
  static async loadMetadataIndex() {
    try {
      const response = await fetch(`${import.meta.env.BASE_URL}data/metadata/index.json`)
      if (!response.ok) {
        console.warn('Index des métadonnées non trouvé')
        return []
      }
      
      const index = await response.json()
      console.log(`📋 Index métadonnées chargé: ${index.totalFiles} fichiers disponibles`)
      return index.files || []
    } catch (error) {
      console.warn('Erreur lors du chargement de l\'index métadonnées:', error)
      return []
    }
  }

  // Obtenir les métadonnées d'un épisode par son ID
  static getMetadataByEpisodeId(episodeId) {
    if (!this.metadataCache) {
      console.warn('Cache des métadonnées non initialisé')
      return null
    }

    return this.metadataCache.find(meta => meta.episode_id === episodeId) || null
  }

  // Obtenir l'URL audio d'un épisode
  static getAudioUrl(episodeId) {
    const metadata = this.getMetadataByEpisodeId(episodeId)
    return metadata?.audio_url || null
  }

  // Obtenir la date de publication d'un épisode
  static getPublicationDate(episodeId) {
    const metadata = this.getMetadataByEpisodeId(episodeId)
    return metadata?.pub_date || null
  }

  // Obtenir la description d'un épisode
  static getDescription(episodeId) {
    const metadata = this.getMetadataByEpisodeId(episodeId)
    return metadata?.description || null
  }

  // Obtenir le titre d'un épisode depuis les métadonnées
  static getTitle(episodeId) {
    const metadata = this.getMetadataByEpisodeId(episodeId)
    return metadata?.title || null
  }

  // Méthode getAllMetadata qui utilise le cache ou charge les données
  static async getAllMetadata() {
    if (this.metadataCache) {
      return this.metadataCache
    }
    return await this.loadAllMetadata()
  }

  // Initialiser le service (à appeler au démarrage de l'app)
  static async initialize() {
    console.log('🏷️ Initialisation du service de métadonnées...')
    await this.loadAllMetadata()
    console.log('✅ Service de métadonnées initialisé')
  }
}